// angular
import { Component, input } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';

@Component({
  selector: 'pwj-tender-meta-card',
  standalone: true,
  imports: [TranslateModule],
  templateUrl: './tender-meta-card.component.html',
  styleUrl: './tender-meta-card.component.scss',
})
export class TenderMetaCardComponent {
  label = input.required<string>();
  value = input.required<string>();
  valueClass = input<string>('');
}
